import { marked } from 'marked'
import { replaceLatexWithMathMl } from '~/utils/mathml'

marked.setOptions({
  breaks: true, // Convert line breaks (\n) to <br> tags for better chat formatting
  gfm: true, // Enable GitHub Flavored Markdown (tables, strikethrough, autolinks, etc.)
})

export function renderMarkdownWithMath(text: string): string {
  // First convert LaTeX formulas ($...$, $$...$$) to MathML for proper rendering
  const textWithMath = replaceLatexWithMathMl(text)

  // Parse markdown to HTML (marked escapes HTML by default for security)
  return marked.parse(textWithMath, { async: false }) as string
}
